import React, { useEffect, useMemo, useState } from "react";
import ListEmploees from "../components/employees/ListEmploees";
import ApiData from "../api/ApiData";
import { observer } from "mobx-react-lite";
import Loader from "../components/Loader";
import Memory from "../api/Memory";
import { Navigate } from "react-router-dom";
import RolesState from "../api/RolesState";
import { filterEmployeesBySearch } from "../utils/employeesSearchUtils";

const Employees = observer(() => {
  const [search, setSearch] = useState("");
  const [listLoading, setListLoading] = useState(true);

  useEffect(() => {
    Memory.funcSelectDayPeriodFlag(false);
    let cancelled = false;
    (async () => {
      setListLoading(true);
      try {
        await ApiData.getDataEmployees();
      } finally {
        if (!cancelled) {
          setListLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const activeEmployees = useMemo(() => {
    return (ApiData.employees_dates ?? []).filter(
      (employee) => employee.is_active,
    );
  }, [ApiData.employees_dates]);

  const filteredEmployees = useMemo(() => {
    return filterEmployeesBySearch(activeEmployees, search);
  }, [activeEmployees, search]);

  if (RolesState.emploees) {
    return (
      <div className="main-page company-card-v4 employees-list-page-v4">
        {!listLoading ? (
          <>
            <header className="card header-card employees-list-page-header">
              <div className="header-top">
                <div className="company-title">
                  <div className="compamy-title-name-container">
                    <span className="req-label">Каталог</span>
                    <h1>Сотрудники</h1>
                  </div>
                </div>
              </div>
            </header>
            <ListEmploees
              users={filteredEmployees}
              search={search}
              setSearch={setSearch}
              hasActiveEmployees={activeEmployees.length > 0}
              searchActive={search.trim().length > 0}
            />
          </>
        ) : (
          <Loader />
        )}
      </div>
    );
  }
  return <Navigate to="/noright" />;
});

export { Employees };
